<template>
    <v-card>
        <v-card-title class="pa-0">
            <v-toolbar rounded dense :light="$vuetify.theme.dark" :dark="!$vuetify.theme.dark">
                <v-toolbar-title>{{ editMode ? (formData.name || campaign.name) : $t('newCampaign') }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <uv-button :color="!$vuetify.theme.dark ? 'white' : 'uv-cancel'" icon @click="$emit('close')">
                        <v-icon >$close</v-icon>
                    </uv-button>
                </v-toolbar-items>
            </v-toolbar>
        </v-card-title>
        <validation-observer slim v-slot="{handleSubmit, invalid}">
            <v-card-text>
                <v-row>
                    <v-col cols="8">
                        <uv-text-field v-model="formData.name"
                        :label="$t('labels.name')"
                        rules="required"
                        clearable
                        >
                        </uv-text-field>
                    </v-col>
                    <v-col md="2">
                        <uv-date-field v-model="formData.date_start"
                        :label="$t('labels.dateStart')"
                        rules="required"
                        no-icon
                        ></uv-date-field>
                    </v-col>
                    <v-col md="2">
                        <uv-date-field v-model="formData.date_stop"
                        :label="$t('labels.dateStop')"
                        rules="required"
                        no-icon
                        ></uv-date-field>
                    </v-col>
                    <!-- <v-col cols="12" md="2">
                        <uv-vehicle-brands-field v-model="formData.brand_id"
                        :label="$t('labels.brand')"
                        rules="required"
                        clearable
                        >
                        </uv-vehicle-brands-field>
                    </v-col> -->
                    <v-col cols="12" md="4">
                        <uv-vehicle-model-field v-model="formData.model_id"
                        :label="$t('labels.carModel')"
                        :brand-ids="[formData.brand_id]"
                        clearable
                        >
                        </uv-vehicle-model-field>
                    </v-col>
                    <v-col cols="12" md="8">
                        <uv-vehicle-submodel-field v-model="formData.submodel_id"
                        :label="$t('labels.submodel')"
                        :model-ids="[formData.model_id]"
                        :settings="{showGmud: true, searchGmud: true, searchModelYear:true}"
                        ></uv-vehicle-submodel-field>
                    </v-col>
                    
                    <v-col md="4">
                        <uv-number-field v-model="formData.importer_discount"
                        :label="$t('labels.suportImportator')"
                        persistent-placeholder
                        @change="valueChanged('importer_discount')"
                        >
                        <template #append>
                            <v-icon small color="info" class="pt-2">$eur</v-icon>
                        </template>
                        <template #append-outer>
                            <uv-number-field v-model="formData.importer_discount_percentage"
                            @change="valueChanged('importer_discount_percentage')"
                            >
                                <template #append><span class="pt-1 info--text">%</span></template>
                            </uv-number-field>
                            </template>
                        </uv-number-field>
                    </v-col>
                    <v-col md="4">
                        <uv-number-field v-model="formData.dealer_discount"
                        :label="$t('labels.dealerDiscount')"
                        persistent-placeholder
                        @change="valueChanged('dealer_discount')"
                        >
                        <template #append>
                            <v-icon small color="info" class="pt-2">$eur</v-icon>
                        </template>
                        <template #append-outer>
                            <uv-number-field v-model="formData.dealer_discount_percentage"
                            @change="valueChanged('dealer_discount_percentage')"
                            >
                                <template #append><span class="pt-1 info--text">%</span></template>
                            </uv-number-field>
                            </template>
                        </uv-number-field>
                    </v-col>
                    <v-col md="4">
                        <uv-number-field v-model="formData.credit_note"
                        :label="$t('labels.creditNote')"
                        persistent-placeholder
                        @change="valueChanged('credit_note')"
                        >
                        <template #append>
                            <v-icon small color="info" class="pt-2">$eur</v-icon>
                        </template>
                        <template #append-outer>
                            <uv-number-field v-model="formData.credit_note_percentage"
                            @change="valueChanged('credit_note_percentage')"
                            >
                                <template #append><span class="pt-1 info--text">%</span></template>
                            </uv-number-field>
                            </template>
                        </uv-number-field>
                    </v-col>
                    <v-col cols="12">
                        <uv-textarea v-model="formData.description"
                        :label="$t('labels.description')"
                        clearable
                        >
                        </uv-textarea>
                    </v-col>
            
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <uv-button color="grey" text @click="$emit('close')">
                    {{$t('close')}}
                </uv-button>
                <uv-button color="success" :loading="loading" :disabled="invalid || !Object.keys(dirtyFields).length" @click="handleSubmit(save)">
                    {{$t('save')}}
                </uv-button>
            </v-card-actions>
        </validation-observer>
    </v-card>
</template>

<script>
export default {
    name: "CampaignForm",
    props: {
        campaign: {
            type: Object,
            required: true,
        }
    },
    data(){
        return{
            formData: {...this.campaign},
            loading: false
        }
    },
    computed:{
        editMode(){
            return this.campaign.id != null
        },
        dirtyFields(){
            const obj = Object.fromEntries(Object.entries(this.formData).filter(([key, value]) => value !== this.campaign[key]))
            if (!this.editMode){
                obj.brand_id = this.formData.brand_id
            }
            return obj
        }
    },
    methods:{
        valueChanged(key){
            if (!this.formData[key]){
                this.formData[key] = 0
            }
            if (this.formData[key]){
                if (key.includes('percentage')){
                    this.formData[key.replace('_percentage', '')] = 0
                }else{
                    this.formData[key + '_percentage'] = 0
                }
            }
        },
        save(){
            this.loading = true
            this.$apiHttp({
                url: this.editMode ? `/campaigns/${this.campaign.id}` : '/campaigns',
                method: this.editMode ? 'put' : 'post',
                data: this.dirtyFields
            }).then((res) => {
                this.$emit('saved', res.data)
                this.$store.commit("SET_globalMessage", {type: 'success', message: this.$t('alerts.success')})
            }).finally(() => {
                this.loading = false
            })
        }
    }
}
</script>
<style lang="scss" scoped>
:deep(.v-input__append-outer){
    margin-top:0px;
    width:100%;
    display: block;
    .v-input{
        margin-top:0px;
        padding-top: 0px;
    }
}
</style>